import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as yup from 'yup'
import { selectForgotPasswordState, setIsPasswordSuccessfullyChanged } from '../features/resetPassword/forgotPasswordSlice'
import { useFormik } from 'formik'
import { sendGeneralRequest } from '../features/generalRequest'
import { Grid, Typography, TextField, Button } from '@mui/material'
import { setGeneralMessage } from '../features/global/globalDataSlice'
import colors from '../components/colors'
import Lottie from "lottie-react";
import smallLoadingAnimation from '../icons/lottieAnimations/smallLoading.json'
import { ReactComponent as IconClose } from '../icons/closeButton.svg';
import {BrowserRouter as Router, useNavigate} from 'react-router-dom'
import { makeStyles } from '@mui/styles';
import { texts } from '../components/general/texts'

const validationSchema = yup.object({
    UserName: yup
      .string()
      .required(texts["message-invalid-user-name"]),
})

export const ResetPassword = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const forgotPasswordSliceState = useSelector(selectForgotPasswordState)

    const formik = useFormik({
        initialValues:{
            UserName:''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: {_request: values}, baseUrlKey:'auth', endpoint:'ResetPasswordNew'}))}})

            React.useEffect(()=>{
                if(forgotPasswordSliceState.isPasswordSuccessfullyChanged)
                {
                    dispatch(setGeneralMessage({type: forgotPasswordSliceState.success === true ? 'success' : 'error', message: forgotPasswordSliceState.message}))
                    dispatch(setIsPasswordSuccessfullyChanged(false))
                }
                }, [forgotPasswordSliceState.isPasswordSuccessfullyChanged])

    const useStyles = makeStyles({
        closeButton:{
            fontSize:'1.8rem',
            color:colors.orange,
            borderRadius:'20px',
            '&:hover': {background:colors.white}
        },
        header:{
            color:colors.darkBlue,
            fontFamily:'GerberaBold',
            fontSize:'2rem'
        },
        text:{
            color:colors.gray,
            fontFamily:'GerberaMedium',
            fontSize:'1.3rem'
        },
        textField:{
            width:'15%',
            '@media (max-width: 899px )' : {width:'60%'}
        },
        submitButton:{
            background:colors.gradientOrange,
            color:colors.white,
            width:'10%',
            fontFamily:'GerberaBold',
            textTransform:'none',
            '@media (max-width: 899px )' : {width:'30%'}
        }
    })

    const classes = useStyles()

  return (
    <form>
        <Grid container rowSpacing={5} pt={10} >
            <Grid container item md={10} xs={10} justifyContent={'right'} pb={10}>
                <Button className={classes.closeButton} onClick={() => {navigate('/forgotUserMain')}} ><IconClose /></Button>
            </Grid>
            <Grid item md={12} xs={12}  pt={20}>
                <Typography className={classes.header}>{texts["button-forgot-password"]}</Typography>
            </Grid>
            <Grid item md={12} xs={12} >
                <Typography className={classes.text}>{texts["message-subtitle-reset-password"]}</Typography>
            </Grid>
            <Grid container item md={12} xs={12} mt={5} pb={30} justifyContent={'center'}>
                <TextField id="UserName" name="UserName" size='small' label={texts["placeholder-user"]} variant="outlined" className={classes.textField} onChange={formik.handleChange} value={formik.values.UserName} error={formik.touched.UserName && Boolean(formik.errors.UserName)} helperText={formik.touched.UserName && formik.errors.UserName} color="warning"/>    
            </Grid>
            <Grid container item md={12} xs={12} justifyContent={' center'} sx={{position: 'sticky'}} paddingBottom={{xs:2}}>
                <Button disabled={forgotPasswordSliceState.isLoading ? true : false} type='submit' onClick={formik.handleSubmit} className={classes.submitButton}>{texts["button-continue"]}</Button>
            </Grid>
            <Grid container justifyContent={'center'} sx={{position: 'fixed', bottom: 5}} >
                <Grid container item md={1} xs={1} >
                    {forgotPasswordSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}    
                </Grid>
            </Grid>          
        </Grid>
    </form>
  )
}
export default ResetPassword